import { z } from 'zod';

export const AutoFullScanEligibilitySchema = z.object({
  eligible: z.boolean(),
  reason: z.enum(['eligible', 'not_pro', 'not_needed', 'active_job', 'gmail_not_ready', 'attempt_consumed', 'unavailable']),
});
export type AutoFullScanEligibility = z.infer<typeof AutoFullScanEligibilitySchema>;

/**
 * Subscription API Request/Response Validation Schemas
 */

export const SubscriptionStatusSchema = z.object({
  tier: z.enum(['free', 'pro']),
  status: z.enum(['active', 'canceled', 'past_due', 'expired']),
  emails_scanned_total: z.number().int().nonnegative(),
  emails_limit: z.number().int().nonnegative().nullable(),
  emails_remaining: z.number().int().nonnegative().nullable(),
  expires_at: z.string().datetime({ offset: true }).nullable(),
  upgrade_url: z.string().url(),
  manage_url: z.string().url().nullable(),
  // True when a Pro user has not yet completed their first unlimited
  // (non-free-sample) full scan - i.e. the post-upgrade full scan is still
  // owed. Always false for free-tier users.
  needs_full_scan: z.boolean(),
  auto_full_scan_eligibility: AutoFullScanEligibilitySchema.optional(),
});

export type SubscriptionStatus = z.infer<typeof SubscriptionStatusSchema>;

export const CheckoutRequestSchema = z.object({
  plan: z.enum(['premium_annual', 'premium_monthly']),
  success_url: z.string().url(),
  cancel_url: z.string().url(),
});

export type CheckoutRequest = z.infer<typeof CheckoutRequestSchema>;

export const CheckoutResponseSchema = z.object({
  checkout_url: z.string().url(),
});

export type CheckoutResponse = z.infer<typeof CheckoutResponseSchema>;

export const WebhookRequestSchema = z.object({
  provider: z.string(),
  event: z.string(),
  payload: z.record(z.string(), z.unknown()),
});

export type WebhookRequest = z.infer<typeof WebhookRequestSchema>;
